"use client";

import "../../layout/Hero/Hero.scss";
import "./CareersList.scss";
import React, { useEffect, useState } from "react";
import { getCollection } from "@/lib/firebase/firestore";
import Link from "next/link";
import Image from "next/image";

const CareersList = () => {
  const [list, setList] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const data = await getCollection("positions");

      setList(
        data
          .filter((el) => el.isArchived !== true)
          .sort((a, b) => a.order - b.order),
      );
    };

    fetchData();
  }, []);

  return (
    <section className=" position">
      <div className="careers__container position__container">
        <h3 className="position__title">open positions</h3>
        <ul className="position__list">
          {list.length > 0 ? (
            list.map((el) => (
              <li className="position__item" key={el.id}>
                <Link href={`careers/${el.id}`} className="position__link">
                  <span>{el.name} </span>
                  <Image
                    className={"position__arrow-icon"}
                    src={"/images/arrow-right.svg"}
                    alt="arrowRight"
                    height={40}
                    width={32}
                  />
                </Link>
              </li>
            ))
          ) : (
            <p className="position__empty">
              We currently have no openings available :&#40;
            </p>
          )}
        </ul>
      </div>
    </section>
  );
};

export default CareersList;
